import axios from "~/plugins/axios";

export default {
  paginateActive(page = 1, perPage = 15) {
    return axios.get("/web_api/v1/user/active", { params: { page, perPage } }).then((response) => response.data);
  },
  paginateInactive(page = 1, perPage = 15) {
    return axios.get("/web_api/v1/user/inactive", { params: { page, perPage } }).then((response) => response.data);
  },
  getMe() {
    return axios.get("/web_api/v1/user/me").then((response) => response.data);
  },
  getUsersByIds(userIds) {
    return axios.post("/web_api/v1/user/by_ids", { user_ids: userIds }).then((response) => response.data);
  },
  getUserById(id, includes = []) {
    return axios.get(`/web_api/v1/user/${id}`, {
      params: {
        includes,
      },
    }).then((response) => response.data);
  },
  searchByName(name) {
    return axios.post("/web_api/v1/user/search/by_name", { query: name }).then((response) => response.data);
  },
  getByExtension(extension) {
    return axios.get(`/web_api/v1/user/by_extension/${extension}`).then((response) => response.data);
  },
  getUserExtensions(userId) {
    return axios.get(`/web_api/v1/user/${userId}/extensions`).then((response) => response.data);
  },
  activateUser(userId) {
    return axios.post(`/web_api/v1/user/activate/${userId}`).then((response) => response.data);
  },
  deactivateUser(userId, force = false, responsibilitiesHandoverTo = {}) {
    return axios.post(`/web_api/v1/user/deactivate/${userId}`, {
      user_id: userId,
      force,
      responsibilities_handover_to: responsibilitiesHandoverTo,
    }).then((response) => response.data);
  },
};
